"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styled = require("./styled");
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const Container = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    alignItems = 'normal',
    children,
    display = 'flex',
    flex = '0 1 auto',
    flexDirection = 'column',
    gap = '0px',
    height = 'auto',
    id,
    justifyContent = 'normal',
    margin = '0px',
    minWidth,
    overflowX = 'visible',
    overflowY = 'visible',
    padding = '0px',
    position = 'relative',
    print = true,
    screen = true,
    whiteSpace = 'normal',
    width = 'auto',
    wordWrap = 'normal'
  } = _ref;
  const containerProps = {
    alignItems,
    display,
    flex,
    flexDirection,
    gap,
    height,
    id,
    justifyContent,
    margin,
    minWidth,
    overflowX,
    overflowY,
    padding,
    position,
    print,
    screen,
    whiteSpace,
    width,
    wordWrap
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.StyledDiv, _objectSpread(_objectSpread({}, containerProps), {}, {
    ref: ref,
    children: children
  }));
});
Container.propTypes = {
  alignItems: _propTypes.default.string,
  children: _propTypes.default.any,
  display: _propTypes.default.string,
  flex: _propTypes.default.string,
  flexDirection: _propTypes.default.string,
  gap: _propTypes.default.string,
  height: _propTypes.default.string,
  id: _propTypes.default.string,
  justifyContent: _propTypes.default.string,
  margin: _propTypes.default.string,
  minWidth: _propTypes.default.string,
  padding: _propTypes.default.string,
  position: _propTypes.default.string,
  print: _propTypes.default.bool,
  screen: _propTypes.default.bool,
  whiteSpace: _propTypes.default.string,
  width: _propTypes.default.string,
  wordWrap: _propTypes.default.string
};
var _default = exports.default = Container;